import { IFieldEnum } from '@samc/centricity-core';
import { ArrayDataSource } from './BaseDataSources';

export class FieldEnumSource extends ArrayDataSource<IFieldEnum> {
  public constructor(fieldId: number) {
    super(`/componentapi/dataimport/internalFields/${fieldId}/enums`, { });
  }
}